import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import "./group_events_modal_more_about_this.css";

const context = require.context("./", true, /_controller\.js$/);
application.load(definitionsFromContext(context));